import * as React from "react";
const ShoppingCartView = React.lazy(() => import("./ShoppingCartView/ShoppingCartContainer"));
const CommerceOrderView = React.lazy(() => import("./OrderView/OrderViewContainer"));
const CommerceQuoteView = React.lazy(() => import("./QuoteView/QuoteViewContainer"));
const SuccessView = React.lazy(() => import("./SuccessView/SuccessContainer"));

export { ShoppingCartView, CommerceOrderView, CommerceQuoteView, SuccessView };
